import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import React, { ReactElement, FunctionComponent } from 'react'
import BasicText from '../../../Theme/Fonts/BasicText'
import { backgroundToFontColorMap, ColorsMapType } from '../../../utils/Colors'
import { TestID } from '../../../utils/PropTypesDefinitions'
import LinkProps from '../../../Link/LinkProps'

export type TabProps = {
    /** Text of the tab */
    title: string
    /** shows if the Tab is selected */
    isActive?: boolean
    /** displays the highlighted version of type = onyx with different border color*/
    isHighlight?: boolean
    /** Sets the background color */
    backgroundColor?: 'onyx' | 'pearl' | 'BLACK'
    /** Determines if the tab occupies the whole space available */
    expand?: boolean
    /** Redirects user to the value assigned */
    href?: string
    /** the callback when the user presses on the forward icon
     *
     * @TJS-type function
     * */
    onPress?: () => void
} & LinkProps &
    TestID

export const getColorsByType = (
    type: string,
    colorsMap: ColorsMapType,
    isActive?: boolean,
    isHighlight?: boolean
) => {
    if (isHighlight && isActive) {
        return {
            backgroundColor: 'onyx',
            borderColor: 'ORANGE',
            color: 'pearl',
        }
    }
    return {
        backgroundColor: type,
        borderColor: colorsMap[type],
        color: colorsMap[type],
    }
}

export const getInactiveFontColorByType = (type: 'onyx' | 'pearl' | 'BLACK' | undefined) => {
    if (type === 'pearl') {
        return 'onyx'
    }
    return 'GRAY66'
}

export const getBackgroundColorBorder = (
    isBackgroundColorBorder: boolean,
    type: string,
    isHighlight?: boolean,
    isActive?: boolean
) => {
    if (isBackgroundColorBorder && isActive && isHighlight) {
        return { backgroundColor: 'ORANGE' }
    } else if (isBackgroundColorBorder && isHighlight) {
        return { backgroundColor: 'ORANGE' }
    } else if (isBackgroundColorBorder && isActive) {
        return { backgroundColor: backgroundToFontColorMap[type] }
    }
    return { backgroundColor: type }
}

const Tab: FunctionComponent<TabProps> = ({
    title,
    isActive,
    backgroundColor = 'onyx',
    expand,
    href,
    onPress,
    testID,
    webRel,
    isHighlight,
}): ReactElement => {
    const {
        backgroundColor: mappedBackgroundColor,
        color,
        borderColor,
    } = getColorsByType(backgroundColor, backgroundToFontColorMap, isActive, isHighlight)
    return (
        <Grid noExpand horizontal={!expand} testID={testID}>
            <Touchable onPress={onPress} href={href} webRel={webRel}>
                <Grid
                    height={41}
                    paddingX={5}
                    centerVertical
                    noExpand
                    horizontal={!expand}
                    backgroundColor={mappedBackgroundColor}
                >
                    <BasicText
                        fontSize="FS14"
                        lineHeight="LH16"
                        color={isActive ? color : getInactiveFontColorByType(backgroundColor)}
                        textAlign="center"
                        bold
                        numberOfLines={1}
                    >
                        {title}
                    </BasicText>
                </Grid>
                <Grid
                    height={2}
                    backgroundColor={isActive ? borderColor : backgroundColor}
                    noExpand
                />
                <Grid
                    height={1}
                    backgroundColor={
                        getBackgroundColorBorder(true, backgroundColor, isHighlight, isActive)
                            .backgroundColor
                    }
                    noExpand
                />
            </Touchable>
        </Grid>
    )
}

export default Tab
